// extracted by mini-css-extract-plugin
var _1 = "FormikEntityActionTypeField-moduletooltip__MXZSi";
export { _1 as "tooltip" }
